import { render, staticRenderFns } from "./Following.vue?vue&type=template&id=958cbd9c&scoped=true&"
import script from "./Following.vue?vue&type=script&lang=js&"
export * from "./Following.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958cbd9c",
  null
  
)

export default component.exports